import { render, staticRenderFns } from "./MultipointServicePaymentDetail.vue?vue&type=template&id=537fd158&scoped=true&"
import script from "./MultipointServicePaymentDetail.vue?vue&type=script&lang=js&"
export * from "./MultipointServicePaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./MultipointServicePaymentDetail.vue?vue&type=style&index=0&id=537fd158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537fd158",
  null
  
)

export default component.exports